import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
function IntegrationStatusIndicatorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 2);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Active");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-check");
} }
function IntegrationStatusIndicatorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 3);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(2, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-warning-octagon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r0.errorMessage);
} }
function IntegrationStatusIndicatorComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 5);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Inactive");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-disable");
} }
function IntegrationStatusIndicatorComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 6);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Inactive");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-soon");
} }
/**
 * Integration Status Indicator Component
 *
 * This component will display the current status of an integration, either active, inactive, or in need of review
 *
 * Input Properties:
 *  status: String representing the current state of the integration
 *  errorMessage: String that will be displayed to the user if the integration is in the NEEDS_REVIEW state
 */
export class IntegrationStatusIndicatorComponent {
}
IntegrationStatusIndicatorComponent.ɵfac = function IntegrationStatusIndicatorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IntegrationStatusIndicatorComponent)(); };
IntegrationStatusIndicatorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IntegrationStatusIndicatorComponent, selectors: [["ycn-integration-status-indicator"]], inputs: { status: "status", errorMessage: "errorMessage" }, standalone: false, decls: 4, vars: 4, consts: [["class", "table-status", 4, "ngIf"], [1, "table-status"], ["ycnIcon", "", 1, "icon-check", "text-green", 3, "name"], ["ycnIcon", "", 1, "icon-warning-octagon", "text-orange", "flex-none", 3, "name"], [3, "textContent"], ["ycnIcon", "", 1, "icon-disable", "text-red", 3, "name"], ["ycnIcon", "", 1, "icon-soon", 3, "name"]], template: function IntegrationStatusIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, IntegrationStatusIndicatorComponent_div_0_Template, 4, 1, "div", 0)(1, IntegrationStatusIndicatorComponent_div_1_Template, 3, 2, "div", 0)(2, IntegrationStatusIndicatorComponent_div_2_Template, 4, 1, "div", 0)(3, IntegrationStatusIndicatorComponent_div_3_Template, 4, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.status === "active");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.status === "needs_review");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.status === "inactive");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.status === "coming_soon");
    } }, dependencies: [i1.NgIf, i2.IconDirective], encapsulation: 2 });
